export const painPoints = [
  { emoji: '📱', text: 'Your phone never stops: “What is the WiFi password?” at 11 p.m., every single stay.' },
  { emoji: '🔑', text: 'Every check-in turns into a phone call, a lockbox drama, or a late-night meet-up.' },
  { emoji: '🧹', text: 'Your cleaner misses the same things, and you only find out from a review.' },
  { emoji: '⭐', text: 'One avoidable misunderstanding costs you a 5-star review — and your ranking.' },
  { emoji: '🧯', text: 'A blown fuse or a broken AC becomes your emergency, at any hour.' },
  { emoji: '🗂️', text: 'Your house rules, codes, and instructions live in ten different messages.' },
]

export const features = [
  {
    title: 'The Ultimate Digital Guest Welcome Guide',
    pain: 'Pain: Endless guest questions',
    description: 'A plug-and-play welcome guide that answers WiFi, parking, appliances, and check-out before a guest ever has to ask.',
  },
  {
    title: 'The Ironclad House Rules & Safety Protocol',
    pain: 'Pain: Damage and disputes',
    description: 'Clear, enforceable rules and safety notices that protect your property without sounding cold or aggressive.',
  },
  {
    title: 'The Local Insider’s Destination Guide',
    pain: 'Pain: Forgettable stays',
    description: 'A curated local recommendations template that turns your listing into an experience guests write reviews about.',
  },
  {
    title: 'The Seamless Self Check-In & Check-Out Blueprint',
    pain: 'Pain: Manual check-ins',
    description: 'Step-by-step self check-in and check-out flows, codes, and photo instructions so arrivals run without you.',
  },
  {
    title: 'The Elite Cleaning & Maintenance SOP',
    pain: 'Pain: Inconsistent turnovers',
    description: 'The exact room-by-room standard your cleaner follows every turnover, with restock lists and sign-off checks.',
  },
  {
    title: 'The Emergency & Troubleshooting Vault',
    pain: 'Pain: Middle-of-the-night crises',
    description: 'Fix-it scripts and escalation paths for power, water, heating, lockouts, and noise — so guests solve it first.',
  },
]

export const bonuses = [
  {
    emoji: '💬',
    tag: 'Bonus #1',
    title: 'The Auto-Pilot Messaging Vault',
    description: '20 pre-written, high-conversion templates for every stage of the guest journey (Booking to Review Request). Just copy, paste, and automate.',
  },
  {
    emoji: '🪧',
    tag: 'Bonus #2',
    title: 'The Printable “Instant Signage” Pack',
    description: 'A set of sleek, minimalist printable signs (WiFi, Trash, No Smoking, No Parties) to keep your home organized and visually professional.',
  },
  {
    emoji: '⭐',
    tag: 'Bonus #3',
    title: 'The 5-Star Review Extractor Script',
    description: 'The psychological messaging sequence designed to turn “happy guests” into “glowing 5-star public reviews” consistently.',
  },
  {
    emoji: '🧺',
    tag: 'Bonus #4',
    title: 'The Smart-Stock Inventory Tracker',
    description: 'A room-by-room checklist to ensure your cleaners never run out of toilet paper, coffee, or essential linens again.',
  },
  {
    emoji: '🧾',
    tag: 'Bonus #5',
    title: 'The Damage Claim & Evidence Log',
    description: 'A structured template to document damages and file insurance claims (AirCover) with professional-grade proof, ensuring you get paid for accidents.',
  },
]

export const offerChecklist = [
  'The Hands-Off Hosting System — complete 6-volume set',
  'Bonus #1 — The Auto-Pilot Messaging Vault',
  'Bonus #2 — The Printable “Instant Signage” Pack',
  'Bonus #3 — The 5-Star Review Extractor Script',
  'Bonus #4 — The Smart-Stock Inventory Tracker',
  'Bonus #5 — The Damage Claim & Evidence Log',
  'Instant digital access — yours forever',
]

export const outcomes = [
  'Cut repetitive guest messages down to almost none.',
  'Run check-in and check-out without being there in person.',
  'Get consistent turnovers, because your cleaner follows one written standard.',
  'Protect your property with rules guests actually read and respect.',
  'Handle emergencies calmly with a script instead of improvising at 2 a.m.',
  'Earn more 5-star reviews from stays that feel effortless.',
]

export const faqs = [
  {
    question: 'Does this work for Airbnb, Booking, and direct bookings?',
    answer: 'Yes. The system is platform-independent. The guides, rules, and scripts work for Airbnb, Booking.com, Vrbo, or guests who book with you directly — you simply drop in your own property details.',
  },
  {
    question: 'I only manage one property. Is this still worth it?',
    answer: 'Absolutely. A single property generates the same repetitive questions, turnovers, and check-ins. Setting the system up once removes that work whether you host one unit or twenty.',
  },
  {
    question: 'How do I receive the system after purchase?',
    answer: 'Immediately. Once your payment is complete, you receive digital access to all six volumes and five bonuses. Use them on your phone, tablet, or computer.',
  },
  {
    question: 'How long does it take to set up?',
    answer: 'Most hosts complete the core setup — welcome guide, house rules, and self check-in flow — in a single afternoon. Everything is a fill-in-the-blank template, not a course to study.',
  },
  {
    question: 'What if it is not right for my property?',
    answer: 'You are protected by a full 7-day guarantee. If you apply the system and it does not reduce the work of hosting your property, we will refund 100% of your investment.',
  },
]
